export { default } from './CommunicationSearchCard';
